import React from 'react';
import MenuPageWrapper from '../Wrappers/MenuPageWrapper.jsx';

export default class EventsWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const menuItems = [
            { icon: "home", title: "Events", href: "/events/" },
            { icon: "boxes", title: "Topics", href: "/events/topics" }
        ];

        return (
            <MenuPageWrapper title={this.props.title || "Events"} menuItems={menuItems} loading={this.props.loading}>
                {this.props.children}
            </MenuPageWrapper>
        );
    }
}
